import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { GetPaymentAndTransactionRequest } from "./useGetPaymentAndTransaction";

async function postRequestReportForTransactionList(data: GetPaymentAndTransactionRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/Transaction/RequestReportForTransactionList", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function usePostRequestReportForTransactionList() {
  return useMutation<any, Error, GetPaymentAndTransactionRequest>(
    (variables) => postRequestReportForTransactionList(variables)
  );
}